/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ClaimRouteImport } from './routes/claim'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as AppEventsRouteImport } from './routes/_app/events'
import { Route as AppFirstRunRouteImport } from './routes/_app/first-run'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as InvitationsIdRouteImport } from './routes/invitations.$id'
import { Route as AppApiKeysIndexRouteImport } from './routes/_app/api-keys/index'
import { Route as AppBagsIndexRouteImport } from './routes/_app/bags/index'
import { Route as AppBagsBagIdRouteImport } from './routes/_app/bags/$bagId'
import { Route as AppDeliveriesIndexRouteImport } from './routes/_app/deliveries/index'
import { Route as AppDestinationsIndexRouteImport } from './routes/_app/destinations/index'
import { Route as AppEventsIndexRouteImport } from './routes/_app/events/index'
import { Route as AppEventsWebhooksRouteImport } from './routes/_app/events/webhooks'
import { Route as AppFormsIndexRouteImport } from './routes/_app/forms/index'
import { Route as AppFormsFormIdRouteImport } from './routes/_app/forms/$formId'
import { Route as AppInboxIndexRouteImport } from './routes/_app/inbox/index'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsMembersRouteImport } from './routes/_app/settings/members'
import { Route as AppStreamsIndexRouteImport } from './routes/_app/streams/index'
import { Route as AppStreamsStreamIdRouteImport } from './routes/_app/streams/$streamId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ClaimRoute = ClaimRouteImport.update({
  id: '/claim',
  path: '/claim',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const AppEventsRoute = AppEventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => AppRoute,
} as any)
const AppFirstRunRoute = AppFirstRunRouteImport.update({
  id: '/first-run',
  path: '/first-run',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const InvitationsIdRoute = InvitationsIdRouteImport.update({
  id: '/invitations/$id',
  path: '/invitations/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AppApiKeysIndexRoute = AppApiKeysIndexRouteImport.update({
  id: '/api-keys/',
  path: '/api-keys/',
  getParentRoute: () => AppRoute,
} as any)
const AppBagsIndexRoute = AppBagsIndexRouteImport.update({
  id: '/bags/',
  path: '/bags/',
  getParentRoute: () => AppRoute,
} as any)
const AppBagsBagIdRoute = AppBagsBagIdRouteImport.update({
  id: '/bags/$bagId',
  path: '/bags/$bagId',
  getParentRoute: () => AppRoute,
} as any)
const AppDeliveriesIndexRoute = AppDeliveriesIndexRouteImport.update({
  id: '/deliveries/',
  path: '/deliveries/',
  getParentRoute: () => AppRoute,
} as any)
const AppDestinationsIndexRoute = AppDestinationsIndexRouteImport.update({
  id: '/destinations/',
  path: '/destinations/',
  getParentRoute: () => AppRoute,
} as any)
const AppEventsIndexRoute = AppEventsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppEventsRoute,
} as any)
const AppEventsWebhooksRoute = AppEventsWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => AppEventsRoute,
} as any)
const AppFormsIndexRoute = AppFormsIndexRouteImport.update({
  id: '/forms/',
  path: '/forms/',
  getParentRoute: () => AppRoute,
} as any)
const AppFormsFormIdRoute = AppFormsFormIdRouteImport.update({
  id: '/forms/$formId',
  path: '/forms/$formId',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxIndexRoute = AppInboxIndexRouteImport.update({
  id: '/inbox/',
  path: '/inbox/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsMembersRoute = AppSettingsMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppStreamsIndexRoute = AppStreamsIndexRouteImport.update({
  id: '/streams/',
  path: '/streams/',
  getParentRoute: () => AppRoute,
} as any)
const AppStreamsStreamIdRoute = AppStreamsStreamIdRouteImport.update({
  id: '/streams/$streamId',
  path: '/streams/$streamId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/claim': typeof ClaimRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/events': typeof AppEventsRouteWithChildren
  '/first-run': typeof AppFirstRunRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/invitations/$id': typeof InvitationsIdRoute
  '/bags/$bagId': typeof AppBagsBagIdRoute
  '/events/webhooks': typeof AppEventsWebhooksRoute
  '/forms/$formId': typeof AppFormsFormIdRoute
  '/settings/members': typeof AppSettingsMembersRoute
  '/streams/$streamId': typeof AppStreamsStreamIdRoute
  '/api-keys/': typeof AppApiKeysIndexRoute
  '/bags/': typeof AppBagsIndexRoute
  '/deliveries/': typeof AppDeliveriesIndexRoute
  '/destinations/': typeof AppDestinationsIndexRoute
  '/events/': typeof AppEventsIndexRoute
  '/forms/': typeof AppFormsIndexRoute
  '/inbox/': typeof AppInboxIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/streams/': typeof AppStreamsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/claim': typeof ClaimRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/first-run': typeof AppFirstRunRoute
  '/invitations/$id': typeof InvitationsIdRoute
  '/bags/$bagId': typeof AppBagsBagIdRoute
  '/events/webhooks': typeof AppEventsWebhooksRoute
  '/forms/$formId': typeof AppFormsFormIdRoute
  '/settings/members': typeof AppSettingsMembersRoute
  '/streams/$streamId': typeof AppStreamsStreamIdRoute
  '/api-keys': typeof AppApiKeysIndexRoute
  '/bags': typeof AppBagsIndexRoute
  '/deliveries': typeof AppDeliveriesIndexRoute
  '/destinations': typeof AppDestinationsIndexRoute
  '/events': typeof AppEventsIndexRoute
  '/forms': typeof AppFormsIndexRoute
  '/inbox': typeof AppInboxIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/streams': typeof AppStreamsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/claim': typeof ClaimRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/_app/events': typeof AppEventsRouteWithChildren
  '/_app/first-run': typeof AppFirstRunRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/invitations/$id': typeof InvitationsIdRoute
  '/_app/bags/$bagId': typeof AppBagsBagIdRoute
  '/_app/events/webhooks': typeof AppEventsWebhooksRoute
  '/_app/forms/$formId': typeof AppFormsFormIdRoute
  '/_app/settings/members': typeof AppSettingsMembersRoute
  '/_app/streams/$streamId': typeof AppStreamsStreamIdRoute
  '/_app/api-keys/': typeof AppApiKeysIndexRoute
  '/_app/bags/': typeof AppBagsIndexRoute
  '/_app/deliveries/': typeof AppDeliveriesIndexRoute
  '/_app/destinations/': typeof AppDestinationsIndexRoute
  '/_app/events/': typeof AppEventsIndexRoute
  '/_app/forms/': typeof AppFormsIndexRoute
  '/_app/inbox/': typeof AppInboxIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/streams/': typeof AppStreamsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/claim'
    | '/sign-in'
    | '/sign-up'
    | '/events'
    | '/first-run'
    | '/settings'
    | '/invitations/$id'
    | '/bags/$bagId'
    | '/events/webhooks'
    | '/forms/$formId'
    | '/settings/members'
    | '/streams/$streamId'
    | '/api-keys/'
    | '/bags/'
    | '/deliveries/'
    | '/destinations/'
    | '/events/'
    | '/forms/'
    | '/inbox/'
    | '/settings/'
    | '/streams/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/claim'
    | '/sign-in'
    | '/sign-up'
    | '/first-run'
    | '/invitations/$id'
    | '/bags/$bagId'
    | '/events/webhooks'
    | '/forms/$formId'
    | '/settings/members'
    | '/streams/$streamId'
    | '/api-keys'
    | '/bags'
    | '/deliveries'
    | '/destinations'
    | '/events'
    | '/forms'
    | '/inbox'
    | '/settings'
    | '/streams'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/claim'
    | '/sign-in'
    | '/sign-up'
    | '/_app/events'
    | '/_app/first-run'
    | '/_app/settings'
    | '/invitations/$id'
    | '/_app/bags/$bagId'
    | '/_app/events/webhooks'
    | '/_app/forms/$formId'
    | '/_app/settings/members'
    | '/_app/streams/$streamId'
    | '/_app/api-keys/'
    | '/_app/bags/'
    | '/_app/deliveries/'
    | '/_app/destinations/'
    | '/_app/events/'
    | '/_app/forms/'
    | '/_app/inbox/'
    | '/_app/settings/'
    | '/_app/streams/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  ClaimRoute: typeof ClaimRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  InvitationsIdRoute: typeof InvitationsIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/claim': {
      id: '/claim'
      path: '/claim'
      fullPath: '/claim'
      preLoaderRoute: typeof ClaimRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/events': {
      id: '/_app/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof AppEventsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/first-run': {
      id: '/_app/first-run'
      path: '/first-run'
      fullPath: '/first-run'
      preLoaderRoute: typeof AppFirstRunRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/invitations/$id': {
      id: '/invitations/$id'
      path: '/invitations/$id'
      fullPath: '/invitations/$id'
      preLoaderRoute: typeof InvitationsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/api-keys/': {
      id: '/_app/api-keys/'
      path: '/api-keys'
      fullPath: '/api-keys/'
      preLoaderRoute: typeof AppApiKeysIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bags/': {
      id: '/_app/bags/'
      path: '/bags'
      fullPath: '/bags/'
      preLoaderRoute: typeof AppBagsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bags/$bagId': {
      id: '/_app/bags/$bagId'
      path: '/bags/$bagId'
      fullPath: '/bags/$bagId'
      preLoaderRoute: typeof AppBagsBagIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/deliveries/': {
      id: '/_app/deliveries/'
      path: '/deliveries'
      fullPath: '/deliveries/'
      preLoaderRoute: typeof AppDeliveriesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/destinations/': {
      id: '/_app/destinations/'
      path: '/destinations'
      fullPath: '/destinations/'
      preLoaderRoute: typeof AppDestinationsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/events/': {
      id: '/_app/events/'
      path: '/'
      fullPath: '/events/'
      preLoaderRoute: typeof AppEventsIndexRouteImport
      parentRoute: typeof AppEventsRoute
    }
    '/_app/events/webhooks': {
      id: '/_app/events/webhooks'
      path: '/webhooks'
      fullPath: '/events/webhooks'
      preLoaderRoute: typeof AppEventsWebhooksRouteImport
      parentRoute: typeof AppEventsRoute
    }
    '/_app/forms/': {
      id: '/_app/forms/'
      path: '/forms'
      fullPath: '/forms/'
      preLoaderRoute: typeof AppFormsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/forms/$formId': {
      id: '/_app/forms/$formId'
      path: '/forms/$formId'
      fullPath: '/forms/$formId'
      preLoaderRoute: typeof AppFormsFormIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox/': {
      id: '/_app/inbox/'
      path: '/inbox'
      fullPath: '/inbox/'
      preLoaderRoute: typeof AppInboxIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/members': {
      id: '/_app/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AppSettingsMembersRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/streams/': {
      id: '/_app/streams/'
      path: '/streams'
      fullPath: '/streams/'
      preLoaderRoute: typeof AppStreamsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/streams/$streamId': {
      id: '/_app/streams/$streamId'
      path: '/streams/$streamId'
      fullPath: '/streams/$streamId'
      preLoaderRoute: typeof AppStreamsStreamIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppEventsRouteChildren {
  AppEventsWebhooksRoute: typeof AppEventsWebhooksRoute
  AppEventsIndexRoute: typeof AppEventsIndexRoute
}

const AppEventsRouteChildren: AppEventsRouteChildren = {
  AppEventsWebhooksRoute: AppEventsWebhooksRoute,
  AppEventsIndexRoute: AppEventsIndexRoute,
}

const AppEventsRouteWithChildren = AppEventsRoute._addFileChildren(
  AppEventsRouteChildren,
)

interface AppSettingsRouteChildren {
  AppSettingsMembersRoute: typeof AppSettingsMembersRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsMembersRoute: AppSettingsMembersRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  AppEventsRoute: typeof AppEventsRouteWithChildren
  AppFirstRunRoute: typeof AppFirstRunRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppBagsBagIdRoute: typeof AppBagsBagIdRoute
  AppFormsFormIdRoute: typeof AppFormsFormIdRoute
  AppStreamsStreamIdRoute: typeof AppStreamsStreamIdRoute
  AppApiKeysIndexRoute: typeof AppApiKeysIndexRoute
  AppBagsIndexRoute: typeof AppBagsIndexRoute
  AppDeliveriesIndexRoute: typeof AppDeliveriesIndexRoute
  AppDestinationsIndexRoute: typeof AppDestinationsIndexRoute
  AppFormsIndexRoute: typeof AppFormsIndexRoute
  AppInboxIndexRoute: typeof AppInboxIndexRoute
  AppStreamsIndexRoute: typeof AppStreamsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppEventsRoute: AppEventsRouteWithChildren,
  AppFirstRunRoute: AppFirstRunRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppBagsBagIdRoute: AppBagsBagIdRoute,
  AppFormsFormIdRoute: AppFormsFormIdRoute,
  AppStreamsStreamIdRoute: AppStreamsStreamIdRoute,
  AppApiKeysIndexRoute: AppApiKeysIndexRoute,
  AppBagsIndexRoute: AppBagsIndexRoute,
  AppDeliveriesIndexRoute: AppDeliveriesIndexRoute,
  AppDestinationsIndexRoute: AppDestinationsIndexRoute,
  AppFormsIndexRoute: AppFormsIndexRoute,
  AppInboxIndexRoute: AppInboxIndexRoute,
  AppStreamsIndexRoute: AppStreamsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  ClaimRoute: ClaimRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  InvitationsIdRoute: InvitationsIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
